module.exports = __webpack_public_path__ + "img/gachita_4_2.8133679d.png";